import React from "react";

export default function Skills() {
  return (
    <div className="skill container text-center mb-4">
      <h1 className="pt-4 h1-skill-expe">SKILLS</h1>
      <hr className="underline-hr mb-5"></hr>

      <div className="row d-flex justify-content-center">
        <div className="col-xl-3 col-md-4 col-sm-6">
          <div className="card bg-primary text-white mb-3">
            <div className="card-body">
              <i className="fab fa-react fa-3x pb-3"></i>
              <h4 className="card-title">React JS</h4>

              <span className="dot bg-success"></span>
              <span className="dot bg-success"></span>
              <span className="dot bg-secondary"></span>

              <p className="instruction-fx pt-3">BEGINNER/INTERMEDIATE/PRO</p>

              {/* <div class="progress mt-4">
                <div
                  class="progress-bar bg-success"
                  role="progressbar"
                  style={{ width: "25%" }}
                  aria-valuenow="25"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div> */}
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-4 col-sm-6">
          <div className="card bg-primary text-white mb-3">
            <div className="card-body">
              <i className="fab fa-bootstrap fa-3x pb-3"></i>
              <h4 className="card-title">BOOTSTRAP</h4>

              <span className="dot bg-success"></span>
              <span className="dot bg-success"></span>
              <span className="dot bg-secondary"></span>

              <p className="instruction-fx pt-3">BEGINNER/INTERMEDIATE/PRO</p>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-4 col-sm-6">
          <div className="card bg-primary text-white mb-3">
            <div className="card-body">
              <i className="fab fa-js-square fa-3x pb-3"></i>
              <h4 className="card-title">JAVASCRIPT</h4>

              <span className="dot bg-success"></span>
              <span className="dot bg-success"></span>
              <span className="dot bg-secondary"></span>

              <p className="instruction-fx pt-3">BEGINNER/INTERMEDIATE/PRO</p>
            </div>
          </div>
        </div>
      </div>

      <div className="row d-flex justify-content-center">
        <div className="col-xl-3 col-md-4 col-sm-6">
          <div className="card bg-primary text-white mb-3">
            <div className="card-body">
              <i className="fas fa-code fa-3x pb-3"></i>
              <h4 className="card-title">React Redux</h4>

              <span className="dot bg-success"></span>
              <span className="dot bg-success"></span>
              <span className="dot bg-secondary"></span>

              <p className="instruction-fx pt-3">BEGINNER/INTERMEDIATE/PRO</p>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-4 col-sm-6">
          <div className="card bg-primary text-white mb-3">
            <div className="card-body">
              <i className="fas fa-server fa-3x pb-3"></i>
              <h4 className="card-title">REST API</h4>

              <span className="dot bg-success"></span>
              <span className="dot bg-success"></span>
              <span className="dot bg-secondary"></span>

              <p className="instruction-fx pt-3">BEGINNER/INTERMEDIATE/PRO</p>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-4 col-sm-6">
          <div className="card bg-primary text-white mb-3">
            <div className="card-body">
              <i className="fab fa-chrome fa-3x pb-3"></i>
              <h4 className="card-title">RESPONSIVE</h4>

              <span className="dot bg-success"></span>
              <span className="dot bg-success"></span>
              <span className="dot bg-secondary"></span>

              <p className="instruction-fx pt-3">BEGINNER/INTERMEDIATE/PRO</p>
            </div>
          </div>
        </div>
      </div>

      <div className="row d-flex justify-content-center">
        <div className="col-xl-3 col-md-4 col-sm-6">
          <div className="card bg-primary text-white mb-3">
            <div className="card-body">
              <i className="fab fa-css3-alt fa-3x pb-3"></i>
              <h4 className="card-title">CSS</h4>

              <span className="dot bg-success"></span>
              <span className="dot bg-success"></span>
              <span className="dot bg-secondary"></span>

              <p className="instruction-fx pt-3">BEGINNER/INTERMEDIATE/PRO</p>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-4 col-sm-6">
          <div className="card bg-primary text-white mb-3">
            <div className="card-body">
              <i className="fas fa-database fa-3x pb-3"></i>
              <h4 className="card-title">DATABASE</h4>

              <span className="dot bg-success"></span>
              <span className="dot bg-success"></span>
              <span className="dot bg-secondary"></span>

              <p className="instruction-fx pt-3">BEGINNER/INTERMEDIATE/PRO</p>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-4 col-sm-6">
          <div className="card bg-primary text-white mb-3">
            <div className="card-body">
              <i className="fas fa-edit fa-3x pb-3"></i>
              <h4 className="card-title">UI/UX</h4>

              <span className="dot bg-success"></span>
              <span className="dot bg-success"></span>
              <span className="dot bg-secondary"></span>

              <p className="instruction-fx pt-3">BEGINNER/INTERMEDIATE/PRO</p>
            </div>
          </div>
        </div>
      </div>

      <div className="row d-flex justify-content-center">
        <div className="col-xl-3 col-md-4 col-sm-6">
          <div className="card bg-primary text-white mb-3">
            <div className="card-body">
              <i className="fas fa-layer-group fa-3x pb-3"></i>
              <h4 className="card-title">ExpressJS</h4>

              <span className="dot bg-success"></span>
              <span className="dot bg-success"></span>
              <span className="dot bg-secondary"></span>

              <p className="instruction-fx pt-3">BEGINNER/INTERMEDIATE/PRO</p>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-4 col-sm-6">
          <div className="card bg-primary text-white mb-3">
            <div className="card-body">
              <i className="fas fa-table fa-3x pb-3"></i>
              <h4 className="card-title skill-etc-text">MongoDB</h4>

              <span className="dot bg-success"></span>
              <span className="dot bg-success"></span>
              <span className="dot bg-secondary"></span>

              <p className="instruction-fx pt-3">BEGINNER/INTERMEDIATE/PRO</p>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-4 col-sm-6">
          <div className="card bg-primary text-white mb-3">
            <div className="card-body">
              <i className="fas fa-pencil-ruler fa-3x pb-3"></i>
              <h4 className="card-title">3D Interior & Exterior</h4>

              <span className="dot bg-success"></span>
              <span className="dot bg-success"></span>
              <span className="dot bg-success"></span>

              <p className="instruction-fx pt-3">BEGINNER/INTERMEDIATE/PRO</p>
            </div>
          </div>
        </div>
      </div>

      <div className="row d-flex justify-content-center">
        <div className="col-xl-3 col-md-4 col-sm-6">
          <div className="card bg-primary text-white mb-3">
            <div className="card-body">
              <i className="fas fa-globe-americas fa-3x pb-3"></i>
              <h4 className="card-title">English Language</h4>

              <span className="dot bg-success"></span>
              <span className="dot bg-success"></span>
              <span className="dot bg-secondary"></span>

              <p className="instruction-fx pt-3">BEGINNER/INTERMEDIATE/PRO</p>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-4 col-sm-6">
          <div className="card bg-primary text-white mb-3">
            <div className="card-body">
              <i className="fas fa-users fa-3x pb-3"></i>
              <h4 className="card-title skill-etc-text">
                TeamWork & Management
              </h4>

              <span className="dot bg-success"></span>
              <span className="dot bg-success"></span>
              <span className="dot bg-secondary"></span>

              <p className="instruction-fx pt-3">BEGINNER/INTERMEDIATE/PRO</p>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-4 col-sm-6">
          <div className="card bg-primary text-white mb-3">
            <div className="card-body">
              <i className="fas fa-tasks fa-3x pb-3"></i>
              <h4 className="card-title skill-etc-text">Project Management</h4>

              <span className="dot bg-success"></span>
              <span className="dot bg-success"></span>
              <span className="dot bg-secondary"></span>

              <p className="instruction-fx pt-3">BEGINNER/INTERMEDIATE/PRO</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
